import styled from 'styled-components'

type StyledMultiUploaderProps = {
	isDragging: boolean
	isUploading: boolean
}

const StyledMultiFileUploader = styled.div<StyledMultiUploaderProps>`
	position: relative;
	border: 2px dashed ${({ isDragging }) => (isDragging ? '#0080fe' : 'rgba(209, 213, 219, 0.9)')};
	background: ${({ isDragging }) => (isDragging ? 'rgba(0, 128, 254, 0.04)' : '#f9fafb')};
	border-radius: 18px;
	padding: 18px;
	display: flex;
	flex-direction: column;
	gap: 16px;
	transition: border-color 0.2s ease-in-out, background 0.2s ease-in-out,
		box-shadow 0.2s ease-in-out;
	box-shadow: ${({ isDragging }) =>
		isDragging ? '0 8px 24px rgba(15, 23, 42, 0.08)' : '0 2px 6px rgba(15, 23, 42, 0.04)'};

	.uploader__content {
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		gap: 16px;
		flex-wrap: wrap;
	}

	.uploader__icon {
		width: 56px;
		height: 56px;
		border-radius: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 128, 254, 0.12);
		color: #0080fe;

		svg {
			font-size: 24px;
		}
	}

	.uploader__details {
		display: flex;
		flex-direction: column;
		gap: 6px;
		color: #1f2937;
		text-align: center;
		align-items: center;

		h4 {
			font-size: 1rem;
			font-weight: 600;
			margin: 0;
			color: #111827;
		}

		p {
			margin: 0;
			color: #4b5563;
			font-size: 0.85rem;
			max-width: 360px;
		}
	}

	.uploader__actions {
		display: flex;
		gap: 8px;
		flex-wrap: wrap;
		justify-content: center;

		button {
			border: none;
			border-radius: 999px;
			padding: 4px 12px;
			min-height: 30px;
			background: #0080fe;
			color: #f8fafc;
			font-weight: 600;
			font-size: 0.74rem;
			letter-spacing: 0.01em;
			cursor: pointer;
			transition: background 0.2s ease-in-out, transform 0.2s ease-in-out;

			&:hover {
				background: #006fd6;
				transform: translateY(-1px);
			}

			&:disabled {
				background: rgba(148, 163, 184, 0.65);
				cursor: not-allowed;
			}
		}

		.secondary {
			background: transparent;
			border: 1px solid rgba(148, 163, 184, 0.8);
			color: #1f2937;

			&:hover {
				background: rgba(15, 23, 42, 0.04);
				border-color: rgba(100, 116, 139, 0.95);
			}
		}
	}

	.uploader__status {
		font-size: 0.8rem;
		font-weight: 500;
		color: ${({ isUploading }) => (isUploading ? '#0b6ef3' : '#6b7280')};
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		gap: 8px;
	}

	.uploader__error {
		font-size: 0.85rem;
		color: #dc2626;
	}

	.uploader__recent {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin: 0;
		padding: 0;
		list-style: none;

		li {
			background: rgba(0, 128, 254, 0.12);
			color: #0b5394;
			padding: 6px 12px;
			border-radius: 999px;
			font-size: 0.8rem;
		}
	}

	.uploader__widget {
		display: none;
	}
`

export default StyledMultiFileUploader
